import React from 'react';
import { useState, useEffect } from 'react';

function Categories({value, onClickCategory}) {

    const BASE_URL_CAT = 'http://wiki2.promoshoko.ru/wp-json/wp/v2/categories/';//post=1457
    const [taxonomy, setTaxonomy] = useState([]);

    useEffect(() => {
        fetch(BASE_URL_CAT + `/?per_page=99` )
        .then(taxonomy => taxonomy.json())
        .then(data => {
            setTaxonomy(data);
        })
    }, []); 

  return (
    <ul className='list'>
      <li 
      onClick={ () => {
        onClickCategory();
        localStorage.removeItem('category');
      }}
      >Все категории</li>
        {
        //   categories.length > 0
            taxonomy.map((categoryName, i) => (
              <li 
                key={i}
                onClick={ () => {
                  onClickCategory(categoryName.id);
                  localStorage.setItem('category', categoryName.id ? categoryName.id : '');
                  localStorage.setItem('position', categoryName.id ? 'active' : '');
                }}
                className={Number(value) === categoryName.id ? 'active' : ''}
              >{categoryName.name}</li>
             )
          ) 
        //    : (<p>Loading...</p>)
        }
    </ul>
  )
}

export default Categories